"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createOnboardingUrl = createOnboardingUrl;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _templateItem = _interopRequireDefault(require("./common/template-item.js"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _templateNav = _interopRequireDefault(require("./common/template-nav.js"));
var _TemplateModal = _interopRequireDefault(require("../../product-merchandising/template-carousel-section/TemplateModal.js"));
var _merchButton = require("@site/pattern-library-core/merch-button");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const GallerySection = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "GallerySection",
  class: "pl-g36xu08"
});
const Grid = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Grid",
  class: "pl-g1r53zti"
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hps84rc"
});
function createOnboardingUrl(onboardingUrl, template) {
  return onboardingUrl.replace('{lid}', template.lid).replace('{vertical}', template.vertical).replace('{id}', template.templateId).replace('{templateId}', template.templateId);
}

/**
 * WSBGallery Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking Name of the component
 * @param {Object} props.categories Template Categories
 * @param {String} props.modalExitText Template Modal Exit button text
 * @param {String} props.modalPrimaryButtonText Template Modal Primary Button text
 * @param {String} props.modalDisclaimerText Template Modal Disclaimer text
 * @param {String} props.primaryCtaText Primary CTA Text
 * @param {String} props.primaryCtaAriaLabel Primary CTA AriaLabel
 * @param {String} props.secondaryCtaText Secondary CTA Text
 * @param {String} props.secondaryCtaAriaLabel Secondary CTA AriaLabel
 * @param {Array} props.navigationItems Navigation Items
 * @param {String} props.verticalMargin Vertical Outer Spacing value
 * @param {String} props.verticalPadding Vertical Inner Spacing value
 * @returns {React.ReactElement} WSBGallery Component
 * @public
 */

function WSBGallery({
  _name,
  categories,
  categoriesTemplate,
  modalExitText = 'Back',
  modalPrimaryButtonText = 'Start with this template',
  modalDisclaimerText = '1 Month Trial',
  primaryCtaText,
  primaryCtaAriaLabel,
  secondaryCtaText,
  secondaryCtaAriaLabel,
  navigationItems,
  verticalMargin = 'none',
  verticalPadding = 'small',
  defaultVisibleQty = 12,
  loadMoreIncrement = 4,
  showMoreCTA,
  showMoreText,
  headlineLockupNode,
  ...rest
}) {
  let templates = [];
  const expectedAboveFold = 4;
  if (categoriesTemplate?.length) {
    templates = categoriesTemplate.map(el => ({
      ...el?.props
    }));
  } else {
    templates = categories?.templates || [];
  }
  templates?.forEach(template => {
    template.onboardingUrl = createOnboardingUrl(template.onboardingUrl, template);
  });
  const capMaxQty = qty => Math.min(qty, templates?.length);
  const [selectedIndex, setSelectedIndex] = (0, _react.useState)(null);
  const [open, setOpen] = (0, _react.useState)(false);
  const [isActive, setIsActive] = (0, _react.useState)(false);
  const [quantityVisible, setQuantityVisible] = (0, _react.useState)(capMaxQty(defaultVisibleQty));
  const showIncrement = loadMoreIncrement || templates?.length;
  function handleSelectTemplate(index) {
    setSelectedIndex(index);
    setOpen(true);
  }
  function handleExitModal() {
    setSelectedIndex(null);
    setOpen(prevCheck => !prevCheck);
  }
  function showMore() {
    setQuantityVisible(capMaxQty(quantityVisible + showIncrement));
  }
  return /*#__PURE__*/_react.default.createElement(GallerySection, {
    _name: _name,
    dataCy: "wsb-gallery",
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding,
    textAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "headline-wrapper"
  }, /*#__PURE__*/_react.default.isValidElement(headlineLockupNode) ? /*#__PURE__*/_react.default.createElement(_index.default, {
    ...headlineLockupNode.props
  }) : /*#__PURE__*/_react.default.createElement(_index.default, rest)), /*#__PURE__*/_react.default.createElement(_templateNav.default, {
    items: navigationItems
  }), /*#__PURE__*/_react.default.createElement(Grid, null, templates?.map((item, i) => /*#__PURE__*/_react.default.createElement(_templateItem.default, (0, _extends2.default)({
    i: i,
    key: i,
    activeTemplate: isActive === i,
    setActiveTemplate: setIsActive,
    modalFn: () => handleSelectTemplate(i),
    primaryCtaText: primaryCtaText,
    secondaryCtaText: secondaryCtaText,
    primaryCtaAriaLabel: primaryCtaAriaLabel,
    secondaryCtaAriaLabel: secondaryCtaAriaLabel,
    hidden: i >= quantityVisible,
    animateIn: i > defaultVisibleQty || i > expectedAboveFold
  }, item)))), showMoreText && /*#__PURE__*/_react.default.createElement("p", null, showMoreText.replace('{QTY}', quantityVisible).replace('{TOTAL}', templates?.length)), quantityVisible < templates?.length && (/*#__PURE__*/_react.default.isValidElement(showMoreCTA) ? /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    ...showMoreCTA.props,
    onClick: showMore
  }) : /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, (0, _extends2.default)({
    "data-cy": "show-more-button"
  }, showMoreCTA, {
    onClick: showMore
  }))), /*#__PURE__*/_react.default.createElement(_TemplateModal.default, {
    open: open,
    exitAction: () => handleExitModal(),
    selectedTemplate: selectedIndex !== null ? templates[selectedIndex] : null,
    modalExitText,
    modalPrimaryButtonText,
    modalDisclaimerText
  }));
}
var _default = exports.default = WSBGallery;
WSBGallery.propTypes = {
  _name: _propTypes.default.string,
  categories: _propTypes.default.object,
  categoriesTemplate: _propTypes.default.array,
  modalExitText: _propTypes.default.string,
  modalPrimaryButtonText: _propTypes.default.string,
  modalDisclaimerText: _propTypes.default.string,
  primaryCtaText: _propTypes.default.string,
  primaryCtaAriaLabel: _propTypes.default.string,
  secondaryCtaText: _propTypes.default.string,
  secondaryCtaAriaLabel: _propTypes.default.string,
  defaultVisibleQty: _propTypes.default.number,
  loadMoreIncrement: _propTypes.default.number,
  showMoreCTA: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.node]),
  showMoreText: _propTypes.default.string,
  headlineLockupNode: _propTypes.default.node,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};